import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  id: "checkout-modal"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = {
  key: 0,
  class: "modal-content checkout-card"
}
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "brand-lockup" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "row mb-4" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-8 col-sm-9 fw-bold" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "fas fa-spinner fa-pulse"
}
const _hoisted_13 = {
  key: 0,
  class: "row"
}
const _hoisted_14 = { class: "col-8 col-sm-9 fw-bold" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "fas fa-spinner fa-pulse"
}
const _hoisted_17 = {
  key: 1,
  class: "row"
}
const _hoisted_18 = { class: "col-8 col-sm-9 fw-bold" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 1,
  class: "fas fa-spinner fa-pulse"
}
const _hoisted_21 = {
  key: 2,
  class: "row"
}
const _hoisted_22 = { class: "col-8 col-sm-9 fw-bold" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "modal-footer" }
const _hoisted_25 = { class: "m-0 flex-grow-1 d-flex flex-row" }
const _hoisted_26 = { class: "countdown" }
const _hoisted_27 = {
  key: 0,
  class: "circle-wrap"
}
const _hoisted_28 = { class: "inside-circle" }
const _hoisted_29 = {
  key: 1,
  class: "modal-content checkout-card"
}
const _hoisted_30 = { class: "modal-body" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-8 col-sm-9 fw-bold" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  key: 1,
  class: "fas fa-spinner fa-pulse"
}
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-8 col-sm-9 fw-bold" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  key: 1,
  class: "fas fa-spinner fa-pulse"
}
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-8 col-sm-9 fw-bold" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = {
  key: 2,
  class: "fas fa-spinner fa-pulse"
}
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "col-8 col-sm-9 fw-bold" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-8 col-sm-9 fw-bold" }
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-8 col-sm-9 fw-bold" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = {
  key: 1,
  class: "fas fa-spinner fa-pulse"
}
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "col" }
const _hoisted_54 = ["href"]
const _hoisted_55 = { class: "row mb-1" }
const _hoisted_56 = { class: "col input-group" }
const _hoisted_57 = ["value"]
const _hoisted_58 = ["disabled"]
const _hoisted_59 = { class: "row mb-4" }
const _hoisted_60 = { class: "col-sm-5 mb-1 order-2 order-sm-1" }
const _hoisted_61 = { class: "input-group" }
const _hoisted_62 = ["value"]
const _hoisted_63 = { class: "col-sm-7 mb-1 order-1 order-sm-2" }
const _hoisted_64 = { class: "input-group" }
const _hoisted_65 = ["value"]
const _hoisted_66 = {
  class: "input-group-text text-center",
  id: "txt-currency"
}
const _hoisted_67 = ["disabled"]
const _hoisted_68 = { class: "row" }
const _hoisted_69 = {
  key: 0,
  class: "col text-center"
}
const _hoisted_70 = { class: "modal-footer" }
const _hoisted_71 = { class: "m-0 flex-grow-1" }
const _hoisted_72 = { class: "countdown" }
const _hoisted_73 = {
  key: 0,
  class: "circle-wrap"
}
const _hoisted_74 = { class: "inside-circle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isPaid)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[7] || (_cache[7] = _createElementVNode("h5", { class: "modal-title" }, [
                _createElementVNode("i", { class: "fas fa-check-circle me-2 text-success" }),
                _createTextVNode("Pago exitoso ")
              ], -1)),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close btn-close-white btn-sm",
                "data-bs-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  class: "checkout-brand-logo",
                  src: 
                require('../../assets/img/brand/gtr-evolution-logo-color-on-dark.svg')
              ,
                  alt: "GTR Evolution"
                }, null, 8, _hoisted_7)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-4 col-sm-3 text-end" }, "Usuario:", -1)),
                  _createElementVNode("div", _hoisted_10, [
                    (_ctx.paidQuoteData.username != '')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.paidQuoteData.username), 1))
                      : (_openBlock(), _createElementBlock("i", _hoisted_12))
                  ])
                ]),
                (_ctx.paidQuoteData.type === 'subscription')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-4 col-sm-3 text-end" }, "Suscripción:", -1)),
                      _createElementVNode("div", _hoisted_14, [
                        (_ctx.paidQuoteData.subscriptionName != '')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.paidQuoteData.subscriptionName), 1))
                          : (_openBlock(), _createElementBlock("i", _hoisted_16))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.paidQuoteData.type === 'tickets')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col-4 col-sm-3 text-end" }, "Evento:", -1)),
                      _createElementVNode("div", _hoisted_18, [
                        (_ctx.paidQuoteData.username != '')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.paidQuoteData.username), 1))
                          : (_openBlock(), _createElementBlock("i", _hoisted_20))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.paidQuoteData.type === 'tickets')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "col-4 col-sm-3 text-end" }, "Tickets:", -1)),
                      _createElementVNode("div", _hoisted_22, [
                        (_ctx.paidQuoteData.concept != '')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.paidQuoteData.concept), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"row\" data-v-070952f4><div class=\"col text-center\" data-v-070952f4><div class=\"mark-stage\" data-v-070952f4><div class=\"circle-check-strong\" data-v-070952f4><svg class=\"check-glyph\" viewBox=\"0 0 100 100\" fill=\"none\" data-v-070952f4><path d=\"M20 54 L42 76 L82 26\" stroke=\"#121212\" stroke-width=\"20\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-070952f4></path></svg></div></div></div></div><div class=\"row mt-2\" data-v-070952f4><div class=\"col text-center\" data-v-070952f4><div class=\"success-headline\" data-v-070952f4>¡Confirmado!</div><div class=\"success-sub\" data-v-070952f4>¡Felicidades! Su pago ha sido confirmado</div></div></div>", 2))
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                (_ctx.replay)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-secondary my-1",
                      "aria-label": "Replay Bitcoin Party",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.bitcoinParty()))
                    }, [...(_cache[13] || (_cache[13] = [
                      _createElementVNode("i", { class: "fas fa-redo" }, null, -1)
                    ]))]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_26, [
                  (_ctx.paymentReceived)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"circle\" data-v-070952f4><div class=\"mask full\" data-v-070952f4><div class=\"fill\" data-v-070952f4></div></div><div class=\"mask half\" data-v-070952f4><div class=\"fill\" data-v-070952f4></div></div></div>", 1)),
                        _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.countdownBP), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary",
                "data-bs-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.close()))
              }, " Cerrar ")
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _cache[33] || (_cache[33] = _createElementVNode("div", { class: "modal-header" }, [
              _createElementVNode("h5", { class: "modal-title" }, [
                _createElementVNode("i", { class: "fas fa-coins me-2 text-warning" }),
                _createTextVNode("Detalles del pago ")
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close btn-close-white btn-sm",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              })
            ], -1)),
            _createElementVNode("div", _hoisted_30, [
              (_ctx.quote.type === 'subscription')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_31, [
                      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "col-4 col-sm-3 text-end" }, "Usuario:", -1)),
                      _createElementVNode("div", _hoisted_32, [
                        (_ctx.SubscriptionConfig)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.quote.username), 1))
                          : (_openBlock(), _createElementBlock("i", _hoisted_34))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "col-4 col-sm-3 text-end" }, "Suscripción:", -1)),
                      _createElementVNode("div", _hoisted_36, [
                        (_ctx.SubscriptionConfig)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.quote.concept), 1))
                          : (_openBlock(), _createElementBlock("i", _hoisted_38))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "col-4 col-sm-3 text-end" }, "Duración:", -1)),
                      _createElementVNode("div", _hoisted_40, [
                        (_ctx.isVipQuote)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_41, " Academia (" + _toDisplayString(_ctx.quote.duration) + " " + _toDisplayString(_ctx.durationUnitString) + ") + Acelerador de Riqueza ", 1))
                          : (_ctx.quote.duration)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_ctx.quote.duration) + " " + _toDisplayString(_ctx.durationUnitString), 1))
                            : (_openBlock(), _createElementBlock("i", _hoisted_43))
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.quote.type === 'tickets')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_44, [
                      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "col-4 col-sm-3 text-end" }, "Usuario:", -1)),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.quote.username), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "col-4 col-sm-3 text-end" }, "Evento:", -1)),
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.quote.typedData?.eventName), 1)
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_48, [
                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "col-4 col-sm-3 text-end" }, "Total:", -1)),
                _createElementVNode("div", _hoisted_49, [
                  (_ctx.quote.fromAmount)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_50, " $ " + _toDisplayString(_ctx.quote.fromAmount) + " " + _toDisplayString(_ctx.quote.fromCurrency), 1))
                    : (_openBlock(), _createElementBlock("i", _hoisted_51))
                ])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("a", {
                    href: _ctx.paymentRef,
                    target: "_blank"
                  }, [...(_cache[21] || (_cache[21] = [
                    _createElementVNode("div", {
                      id: "qrcontainer",
                      class: "qr_code mx-auto"
                    }, [
                      _createElementVNode("canvas", { id: "qrCanvas" })
                    ], -1)
                  ]))], 8, _hoisted_54)
                ])
              ]),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _cache[23] || (_cache[23] = _createElementVNode("span", { class: "input-group-text" }, [
                    _createElementVNode("i", { class: "fas fa-wallet fa-fw" })
                  ], -1)),
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    placeholder: "Wallet destino",
                    id: "txt-wallet",
                    value: _ctx.quote.address,
                    readonly: ""
                  }, null, 8, _hoisted_57),
                  _createElementVNode("button", {
                    class: "btn btn-secondary",
                    type: "button",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.copyToClipboard('txt-wallet'))),
                    disabled: !_ctx.quote.address
                  }, [...(_cache[22] || (_cache[22] = [
                    _createElementVNode("i", {
                      class: "far fa-copy",
                      id: "buttonCopyWallet",
                      "data-bs-toggle": "tooltip",
                      title: "Copiar"
                    }, null, -1)
                  ]))], 8, _hoisted_58)
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _cache[24] || (_cache[24] = _createElementVNode("span", { class: "input-group-text" }, [
                      _createElementVNode("i", { class: "fas fa-hourglass-half fa-fw" })
                    ], -1)),
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control text-center",
                      placeholder: "Expiración",
                      value: _ctx.expiration.string,
                      disabled: ""
                    }, null, 8, _hoisted_62)
                  ])
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _cache[26] || (_cache[26] = _createElementVNode("span", { class: "input-group-text" }, [
                      _createElementVNode("i", { class: "fab fa-btc fa-fw" })
                    ], -1)),
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control text-end border-end-0",
                      placeholder: "Total",
                      id: "txt-total",
                      value: _ctx.quote.paymentAmount,
                      readonly: ""
                    }, null, 8, _hoisted_65),
                    _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.quote.paymentCurrency), 1),
                    _createElementVNode("button", {
                      class: "btn btn-secondary",
                      type: "button",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.copyToClipboard('txt-total'))),
                      disabled: !_ctx.quote.paymentAmount
                    }, [...(_cache[25] || (_cache[25] = [
                      _createElementVNode("i", {
                        class: "far fa-copy",
                        id: "buttonCopyTotal",
                        "data-bs-toggle": "tooltip",
                        title: "Copiar"
                      }, null, -1)
                    ]))], 8, _hoisted_67)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_68, [
                (_ctx.quote.confirms_needed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                      _cache[27] || (_cache[27] = _createTextVNode(" Todos los paquetes son activados despues de ", -1)),
                      _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.quote.confirms_needed), 1),
                      _cache[29] || (_cache[29] = _createTextVNode(" confirmaciones en el blockchain.", -1)),
                      _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
                      _cache[31] || (_cache[31] = _createTextVNode(" Recibirás un correo cuando el pago se haya acreditado. ", -1))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, [
                  (_ctx.paymentReceived)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                        _cache[32] || (_cache[32] = _createStaticVNode("<div class=\"circle\" data-v-070952f4><div class=\"mask full\" data-v-070952f4><div class=\"fill\" data-v-070952f4></div></div><div class=\"mask half\" data-v-070952f4><div class=\"fill\" data-v-070952f4></div></div></div>", 1)),
                        _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.countdownBP), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (
              _ctx.quote.type === 'subscription' &&
              _ctx.quote.tx_id &&
              _ctx.expiration.difference < 600000
            )
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.renewQuote && _ctx.renewQuote(...args)))
                  }, " Calcular de nuevo "))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary",
                "data-bs-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.close()))
              }, " Cerrar ")
            ])
          ]))
    ])
  ]))
}